import { useEffect, useState } from "react";
import { FaChevronDown, FaBars, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mediaOpen, setMediaOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30); // Change threshold as needed
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 z-50 w-full flex items-center justify-between px-4 md:px-6 py-4 md:flex-row transition-all duration-300 ${
        scrolled
          ? "bg-[#0a1c44] shadow-md"
          : "bg-gradient-to-b from-[#0a1c44] to-transparent"
      } text-white`}
    >
      <div className="flex items-center gap-6">
        <img src="/logo.png" className="md:h-14 h-8" />
        {/* Бургер-меню для мобильных устройств */}
        <button className="text-white hidden" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>
        <ul className={`md:flex md:items-center text-xs md:gap-6 absolute md:static top-16 left-0 w-full bg-[#0a1c44] md:bg-transparent shadow-md md:shadow-none transition-all duration-300 ${menuOpen ? "block" : "hidden"}`}>
          <li onClick={()=>navigate('/payment')} className="p-2 font-semibold cursor-pointer hover:text-gray-300 md:p-0">Home</li>
          <li onClick={()=>navigate('/payment')} className="relative p-2 md:p-0">
            <button className="flex items-center gap-1 text-xs font-semibold hover:text-gray-300" onClick={()=>navigate('/payment')}>
              Festival Activities <FaChevronDown size={12} />
            </button>
            {dropdownOpen && (
              <ul className="absolute left-0 w-40 py-2 mt-2 text-black bg-white rounded shadow-lg top-full md:static md:bg-transparent md:text-white md:shadow-none">
                <li onClick={()=>navigate('/payment')} className="px-4 py-2 text-xs cursor-pointer hover:bg-gray-200 md:hover:bg-transparent">Activity 1</li>
                <li onClick={()=>navigate('/payment')} className="px-4 py-2 text-xs cursor-pointer hover:bg-gray-200 md:hover:bg-transparent">Activity 2</li>
              </ul>
            )}
          </li>
          <li onClick={()=>navigate('/payment')} className="p-2 text-xs font-semibold cursor-pointer hover:text-gray-300 md:p-0">Festival Guide</li>
          <li onClick={()=>navigate('/payment')} className="p-2 text-xs font-semibold cursor-pointer hover:text-gray-300 md:p-0">Plan Your Visit</li>
          <li onClick={()=>navigate('/payment')} className="p-2 text-xs font-semibold cursor-pointer hover:text-gray-300 md:p-0">Partners & Sponsors</li>
          <li onClick={()=>navigate('/payment')} className="relative p-2 md:p-0">
            <button className="flex items-center gap-1 text-xs font-semibold hover:text-gray-300" onClick={()=>navigate('/payment')}>
              Media Center <FaChevronDown size={12} />
            </button>
            {mediaOpen && (
              <ul className="absolute left-0 w-40 py-2 mt-2 text-black bg-white rounded shadow-lg top-full md:static md:bg-transparent md:text-white md:shadow-none">
                <li onClick={()=>navigate('/payment')} className="px-4 py-2 text-xs font-semibold cursor-pointer hover:bg-gray-200 md:hover:bg-transparent">Gallery</li>
                <li onClick={()=>navigate('/payment')} className="px-4 py-2 text-xs font-semibold cursor-pointer hover:bg-gray-200 md:hover:bg-transparent">Press Releases</li>
              </ul>
            )}
          </li>
          <li onClick={()=>navigate('/payment')} className="p-2 text-xs font-semibold cursor-pointer hover:text-gray-300 md:p-0">Contact Us</li>
        </ul>
      </div>
      {/* Кнопки остаются фиксированными для мобильных устройств */}
      <div className="flex items-center gap-4">
        <button onClick={() => navigate('/payment')} className="bg-[#FFD367] text-[#13294b] w-44 h-10 text-sm font-semibold rounded-full hover:bg-yellow-400">
          Book Tickets Now
        </button>
       
      </div>
    </nav>
  );
};

export default Navbar;